import {createContext, useContext} from 'react';
import {UserAgentData} from "@/base/types/external/UserAgentData";

type Props = {
	userAgentData?: UserAgentData
}

const UserAgentContext = createContext<Props>({
	userAgentData: undefined
});

export const useUserAgent = (): Props => {
	return useContext(UserAgentContext);
}

// cart provider

export const UserAgentProvider = ({userAgentData, children}: React.PropsWithChildren<Props>) => {
	return (
		<UserAgentContext.Provider value={{userAgentData}}>
			{children}
		</UserAgentContext.Provider>
	);
}